<template>
  <router-view />
</template>

<script>
export default {
  name: 'JobsWrapper',
};
</script>
